import RingModelsModal from '@/app/components/RingModelsModal';

import { useSizingPageModalContext } from '../contexts/SizingPageModalProvider';

const SizingPageRingModelsModal = (): JSX.Element => {
  const { ringModelsVisible, setRingModelsVisible } =
    useSizingPageModalContext();
  const toggleModal = () => {
    setRingModelsVisible(false);
  };

  return (
    <RingModelsModal isOpen={ringModelsVisible} toggleModal={toggleModal} />
  );
};

export default SizingPageRingModelsModal;
